<template>
  <div>
    <a-modal v-model="changePWModal" width="480px" :footer="null" title="" :closable="false">
      <template :solt="closeIcon">
        <a-icon @click="closeEditPasModel" type="close" class="modalCloseIcon" />
      </template>
      <div class="modelHeader">设置账号及密码</div>
      <!-- oninput="value=value.replace(/^[a-z0-9_]{4,20}$/,'');" -->
      <div class="formLogin">
        <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
          <a-form-model-item prop="account">
            <a-input v-model="ruleForm.account"  allowClear placeholder="请输入登录账号"
             autocomplete="new-password"
            />
          </a-form-model-item>
          <a-form-model-item prop="newPwd">
            <a-input-password v-model="ruleForm.newPwd" type="password" allowClear  autocomplete="new-password"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\s*/g,''); if(value.length > 18)value = value.slice(0, 18)"
              placeholder="登录密码" />
          </a-form-model-item>
          <a-form-model-item prop="repeatNewPwd">
            <a-input-password v-model="ruleForm.repeatNewPwd" type="password" allowClear  autocomplete="new-password"
              oninput="value=value.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|\s*/g,''); if(value.length > 18)value = value.slice(0, 18)"
              placeholder="确认密码" />
          </a-form-model-item>
        </a-form-model>
        <a-button class="button" :loading="btnLoading" @click="changePassword">修改密码</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { post } from "@/utils/http";
import { message } from "ant-design-vue";
import api from "@/api";
import { pwdPublicKeyEncode } from "@/utils/RSAUtils";

export default {
  props: ["value"],
  data() {
    return {
      btnLoading: false,
      changePWModal: this.value,

      ruleForm: {
        account: "",
        newPwd: "",
        repeatNewPwd: "",
      },
      rules: {
        account: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          { pattern: /^[!-~]{4,20}$/, message: "格式不正确，支持小写英文、数字、下划线、长度4～20位", trigger: "change" },
        ],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { pattern: /^(?=(.*[A-Za-z]){1})(?=(.*\d){1})(?=(.*[\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]){1})[A-Za-z\d\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]{10,18}$/, message: '密码需包含字母+数字+特殊字符，长度10～18位', trigger: 'change' },
        ],
        repeatNewPwd: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { pattern: /^(?=(.*[A-Za-z]){1})(?=(.*\d){1})(?=(.*[\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]){1})[A-Za-z\d\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\;\"\'\<\>\,\.\?\/~\©\®]{10,18}$/, message: '密码需包含字母+数字+特殊字符，长度10～18位', trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    value: {
      handler() {
        this.changePWModal = this.value;
      },
    },
    changePWModal: {
      handler() {
        if (!this.changePWModal) {
          this.ruleForm = {
            account: "",
            newPwd: "",
            repeatNewPwd: "",
          };
          this.$emit("input", this.changePWModal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    changePassword() {
      if (this.ruleForm.newPwd !== this.ruleForm.repeatNewPwd) {
        message.error("两次输入密码不一致");
        return;
      }
      setTimeout(() => {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.btnLoading = true;
            let newPassword = await pwdPublicKeyEncode(this.ruleForm.newPwd);
            const params = {
              password: newPassword,
              account: this.ruleForm.account,
            };
            await post(api.accountAndPassword, params)
              .then(() => {
                this.changePWModal = false;
                message.success("账户初始化成功");
              })
              .finally(() => {
                this.btnLoading = false;
              })
              .catch(() => { });
          }
        });
      }, 100);
    },
    closeEditPasModel() {
      this.changePWModal = false;
    },
  },
};
</script>

<style lang="less" scoped>
.sys-sign-out {
  color: #fff;
  //line-height: 60px;
  border-left: 2px solid #e1e4eb;
  //margin: 0 20px 0 30px;
  cursor: pointer;
  font-size: 14px;

  //min-width: 50px;
  .user-name {
    .anticon {
      margin-left: 5px;
    }
  }
}

/deep/ .ant-modal-body {
  padding: 0 56px 56px 56px;

  .modalCloseIcon {
    color: #333;
    top: 24px;
    right: 24px;
    font-size: 22px;
    font-weight: 500;
    position: absolute;
  }

  .modelHeader {
    width: 100%;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    color: #2d3968;
    padding-top: 64px;
  }

  .button {
    height: 48px;
    font-size: 16px;
    letter-spacing: 0px;
  }
}
</style>
